
var _currentNewsPage = 0;
var _currentNewsID = 0;

(function ($) {

    Drupal.behaviors.news = {

        attach: function (context) {

            $(".news", context).each(function (index){

                //Drupal.behaviors.functions.consolog("found news!!!");

                $(".newsTeaserContainer").empty();
                $(".newsTeaserContainer").append("<div class='col-xs-6 col-sm-4 col-md-3 grid-sizer'></div>");

                //init masonry
                $('.newsTeaserContainer').masonry({
                    columnWidth: '.grid-sizer',
                    itemSelector: '.newsTeaser',
                    percentPosition: true,
                    horizontalOrder: true
                });

                $(".preloader").show();

                $(window).resize(handleResize);
                handleResize();

                $(window).scroll(handleScroll);


                //load first json page
                _currentNewsPage = 0;
                loadMoreNews();

                //var jqxhr = $.getJSON( "example.json", function() {
                    //console.log( "success" );
                //})

            });

            function loadMoreNews(){
                var jsonpath = $(".news").attr("data-url") + "?page=" + _currentNewsPage;
                $.getJSON(jsonpath, handleNewsJsonLoaded)
                    .fail(function() {
                        $(".preloader").hide();
                        Drupal.behaviors.functions.consolog("Drupal.behaviors.news() ERROR JSON LOADING");
                    }
                );
            }

            function handleResize(){
                var h = $(window).height() - $(".saphNavHeader").height();
                $(".news").css("min-height", h + "px");
            }


            function handleScroll(){
                $(".newsTeaserContainer").masonry('layout');
            }

            function handleNewsJsonLoaded(data){
                var items = data.data;

                if(items.length > 0){

                    for(var i=0; i<items.length; i++){

                        var newsdata = items[i];

                        _currentNewsID++;

                        if(newsdata.teaser != ""){

                            $(".newsHighlight").find(".newsHighlightImageLink").attr("href", newsdata.link_url);
                            $(".newsHighlight").find(".newsHighlightImageLink").attr("title", newsdata.link_text);

                            $(".newsHighlight").find(".newsHighlightImageLink").children("img").attr("alt", newsdata.link_text);
                            $(".newsHighlight").find(".newsHighlightImageLink").children("img").attr("src", newsdata.img);

                            $(".newsHighlight").find(".newsHighlightDate").html(newsdata.date);

                            $(".newsHighlight").find("h1").html(newsdata.title);

                            $(".newsHighlight").find(".newsHighlightText").html(newsdata.teaser);

                            $(".newsHighlight").find(".newsHighlightLink").attr("data-text", newsdata.link_text);
                            $(".newsHighlight").find(".newsHighlightLink").attr("data-url", newsdata.link_url);
                            $(".newsHighlight").find(".newsHighlightLink").addClass("linkButton");
                        }
                        else{
                            var $em = $("<div></div>");
                            $em.addClass("newsTeaser");
                            $em.addClass("not-lazy-loaded");
                            $em.addClass("col-xs-6 col-sm-4 col-md-3");
                            $em.attr("data-image", newsdata.img);
                            $em.attr("data-id", _currentNewsID);

                            var $imgbox = $("<a></a>");
                            $imgbox.attr("title", newsdata.link_text);
                            $imgbox.attr("href", newsdata.link_url);
                            $em.append($imgbox);

                            //create image
                            var $img = $("<img />");
                            $img.attr("alt", newsdata.title);
                            $img.addClass("lazy");
                            $img.attr("data-src", newsdata.img);
                            $imgbox.append($img);

                            var $date = $("<div></div>");
                            $date.addClass("newsTeaserDate");
                            $date.text(newsdata.date);
                            $em.append($date);

                            var $text = $("<div></div>");
                            $text.addClass("newsTeaserText");
                            $text.text(newsdata.title);
                            $em.append($text);

                            var $link = $("<div data-position-right='true' data-arrow-color='white' data-arrow-background-color='red' data-text-class='link-primary' data-text-color='black' data-is-small='true'></div>");
                            $link.addClass("linkButton");
                            $link.addClass("newsTeaserLink");
                            $link.attr("data-text", newsdata.link_text);
                            $link.attr("data-url", newsdata.link_url);
                            $em.append($link);

                            //append new element to page and to masonry
                            $(".newsTeaserContainer").append($em).masonry('appended', $em);

                            //reload masonry layout for images
                            $(".newsTeaserContainer").masonry('layout');

                        }
                    }

                    //lazy loading (http://jquery.eisbehr.de/lazy/)
                    $(".newsTeaser.not-lazy-loaded").find("img.lazy").Lazy({
                        scrollDirection: 'vertical',
                        threshold: 500,
                        onError: function(element) {
                            $(element).hide();
                        },
                        afterLoad: function(element) {
                            //Drupal.behaviors.functions.consolog("lazy loaded img #" + $(element).parent(".newsTeaser").attr("data-id"));
                            $(element).parent(".newsTeaser").removeClass("not-lazy-loaded");

                            //reload masonry layout for images
                            $(".newsTeaserContainer").masonry('layout');

                            //call masonry again and again for safari....
                            setTimeout(function(){
                                $(".newsTeaserContainer").masonry('layout');
                            }, 500);
                            setTimeout(function(){
                                $(".newsTeaserContainer").masonry('layout');
                            }, 1000);
                            setTimeout(function(){
                                $(".newsTeaserContainer").masonry('layout');
                            }, 2500);
                            setTimeout(function(){
                                $(".newsTeaserContainer").masonry('layout');
                            }, 5000);
                            setTimeout(function(){
                                $(".newsTeaserContainer").masonry('layout');
                            }, 10000);
                        },
                        onFinishedAll: function() {
                            //Drupal.behaviors.functions.consolog("lazy loaded all elements!");

                            $(".preloader").show();

                            //load next set of news...
                            _currentNewsPage++;
                            loadMoreNews();

                            //reload masonry layout for images
                            $(".newsTeaserContainer").masonry('layout');
                        }
                    });

                    //create links
                    Drupal.behaviors.linkButtonCreator($(".news"));
                    Drupal.behaviors.customTextSectionCreator($(".news"));

                }
                else{
                    Drupal.behaviors.functions.consolog("Drupal.behaviors.news() no more news found!");
                }

                $(".preloader").hide();
            }
        }
    };

})(jQuery);
